import type { CSSProperties } from 'react';
import { statusPalette, vdzOrange } from '../../theme/colors';

/** Farben ausschliesslich aus der Palette -- keine neuen Hex-Werte, siehe evaluationTable.module.css.
 *  Auch am Wurzelelement der Tabellen gesetzt, damit Veraenderungs- und Compliance-Spalten sie erben. */
export const cellColorVars = {
  '--eval-blocked-bg': statusPalette.fehler.bg,
  '--eval-blocked-fg': statusPalette.fehler.fg,
  '--eval-recoverable-color': vdzOrange[6],
  '--eval-highlight-bg': vdzOrange[1],
  '--eval-positive-color': statusPalette.freigegeben.fg,
} as CSSProperties;
